import Page from 'components/common/Page'
import Text from 'components/common/Text'
import { Container, Row, Col } from 'react-bootstrap'
import PropertyForm from 'components/common/forms/PropertyForm'
import Link from 'components/common/Link'
import colors from 'utility/colors'
import { toSlug } from 'utility/string'
import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import { useRouter } from 'next/router'
import ResponsiveImage from 'components/common/ResponsiveImage'

export const SearchPage = () => {
	const router = useRouter()

	const { data: tenantProfile } = useTenantProfile()
	const tenantLogo = tenantProfile?.theme?.colorLogo
	const primaryColor = tenantProfile?.theme?.primaryColor

	return (
		<Page title={'Find your property'} footer hideNav>
			<Container style={{ marginBottom: 50, marginTop: 50 }}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						marginTop: 60,
					}}
				>
					<div style={{ width: '100%', maxWidth: 600 }}>
						{tenantLogo ? (
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									justifyContent: 'center',
									alignItems: 'center',
									marginBottom: 20,
								}}
							>
								<ResponsiveImage src={tenantLogo} style={{ width: 300 }} />
							</div>
						) : null}

						<PropertyForm
							withLabels={false}
							promptText={'Enter your home address to start...'}
							height={60}
							inputStyle={{
								padding: 20,
								fontSize: 18,
							}}
							onAdd={(property) => {
								const state = 'texas'
								const slugAddress = toSlug(property?.propertyAddress)
								const searchId = property?.searchId
								router.push(`/${state}/property/${slugAddress}/${searchId}`)
							}}
						/>

						<Link to='/coverage' target={'_blank'} style={{ display: 'inline' }}>
							<Text
								size={14}
								color={colors.GRAY}
								style={{
									display: 'inline',
									marginTop: 8,
									marginLeft: 8,
									textAlign: 'left',
								}}
							>
								Serving{' '}
								<Text
									style={{
										display: 'inline',
										fontStyle: 'italic',
										fontSize: 14,
										color: primaryColor,
									}}
								>
									these Texas counties
								</Text>
							</Text>
						</Link>
					</div>
				</div>
			</Container>
		</Page>
	)
}
